import React from "react";
import { useQuery } from "@tanstack/react-query";
import DynamicStatsInterface from "../../components/admin/dashboard/DynamicStatsInterface";
import StatsGrid from "../../components/admin/dashboard/StatsGrid";
import Header from "../../components/admin/common/Header";
import PageWrapper from "../../components/admin/common/PageWrapper";
import Sidebar from "../../components/admin/common/Sidebar";
import RecentMembersTable from "../../components/admin/dashboard/RecentMembersTable";
import { adminDashboard } from "../../services/adminServices";

const DashBoard = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["adminDashboard"],
    queryFn: async () => {
      const response = await adminDashboard();
      return response.data;
    },
    staleTime: 1000 * 60,
    retry: 1,
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading...
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-red-500 p-4">
        {error?.response?.data?.message || error.message}
      </div>
    );
  }

  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      {/* Sidebar */}
      <div className="h-full">
        <div className="sticky top-0 h-screen text-white">
          <Sidebar />
        </div>
      </div>

      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
        <PageWrapper>
          <div className="flex flex-col h-full">
            <div className="flex-1 p-4 overflow-y-auto">
              <Header
                title="SAP Admin Dashboard"
                desc="Comprehensive overview of all organization members."
              />
              <StatsGrid memberStatistics={data?.memberStatistics} />
              <div className="border-b border-[#0000001A]"></div>
              <DynamicStatsInterface
                contentStatistics={data?.contentStatistics}
              />
              <RecentMembersTable members={data?.recentMembers} />
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default DashBoard;
